/* =====================================================
   POWCHEE — global interactions (Shopify Dawn rebuild)
   Loaded site-wide with `defer`. Owns: scroll progress,
   reveal-on-scroll, count-ups, the home format cards and
   the home buy-box configurator (which deep-links into
   the product page — no duplicate cart logic).
   Dawn owns: header, menu drawer, cart drawer, search.
   All listeners are passive; all work is rAF-batched.
   ===================================================== */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll progress bar + sticky mobile subscribe bar ---- */
  var prog = document.getElementById('progress');
  var hero = document.querySelector('.hero');
  var stickyBuy = document.getElementById('stickyBuy');
  var ticking = false;
  function onScroll(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){
      var h = document.documentElement;
      var st = window.scrollY || h.scrollTop || 0;
      if (prog){
        var max = h.scrollHeight - h.clientHeight;
        prog.style.width = ((max > 0 ? st / max : 0) * 100) + '%';
      }
      if (stickyBuy){
        var heroH = hero ? hero.offsetHeight : 600;
        stickyBuy.classList.toggle('show', st > heroH * 0.7);
      }
      ticking = false;
    });
  }
  if (prog || stickyBuy){
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---- Reveal on scroll (IntersectionObserver, no per-scroll work) ---- */
  var reveals = [].slice.call(document.querySelectorAll('.reveal'));
  function ensureShown(el){ el.style.transition = 'none'; el.classList.add('in'); }
  if (reduce || !('IntersectionObserver' in window)){
    reveals.forEach(ensureShown);
  } else if (reveals.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
        (function(t){ setTimeout(function(){ ensureShown(t); }, 750); })(en.target);
      });
    }, {rootMargin: '0px 0px -8% 0px'});
    reveals.forEach(function(el){ io.observe(el); });
  }

  /* ---- Count-up numbers ---- */
  function format(n, dec){ return dec > 0 ? n.toFixed(dec) : Math.round(n).toLocaleString('en-US'); }
  function animateCount(el){
    var to = parseFloat(el.getAttribute('data-to'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    if (reduce){ el.textContent = format(to, dec); return; }
    var start = null, dur = 1300;
    function step(ts){
      if (start === null) start = ts;
      var t = Math.min((ts - start) / dur, 1);
      el.textContent = format(to * (1 - Math.pow(1 - t, 3)), dec);
      if (t < 1) requestAnimationFrame(step); else el.textContent = format(to, dec);
    }
    requestAnimationFrame(step);
  }
  var counts = [].slice.call(document.querySelectorAll('.countup'));
  if (counts.length){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        animateCount(en.target);
      });
    }, {rootMargin: '0px 0px -5% 0px'});
    counts.forEach(function(el){ cio.observe(el); });
  }

  /* ---- Home: format selector cards (S3) ---- */
  var fmtCards = [].slice.call(document.querySelectorAll('.fmt[data-format]'));
  function selectFmt(card){
    fmtCards.forEach(function(c){ c.classList.remove('sel'); c.setAttribute('aria-pressed','false'); });
    card.classList.add('sel'); card.setAttribute('aria-pressed','true');
    setBuyFormat(card.getAttribute('data-format'));
  }
  fmtCards.forEach(function(card){
    card.addEventListener('click', function(e){ if (!e.target.closest('a')) selectFmt(card); });
    card.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); selectFmt(card); }
    });
  });

  /* ---- Home: buy-box configurator (deep-links to product page) ----
     Pricing comes from the section's data attributes (wired to the real
     product in Liquid) — nothing is hardcoded here. */
  var buyRoot = document.getElementById('powcheeBuyBox');
  var state = { plan:'sub', tier:'90', fmt:'stick' };
  var TIER = null, productUrl = '/';
  if (buyRoot){
    try { TIER = JSON.parse(buyRoot.getAttribute('data-tiers') || 'null'); } catch(e){}
    productUrl = buyRoot.getAttribute('data-product-url') || '/';
  }
  var planSub = document.getElementById('planSub');
  var planOnce = document.getElementById('planOnce');
  var tiers = document.getElementById('tiers');
  var fmtPills = document.getElementById('fmtPills');
  var sumNow = document.getElementById('sumNow');
  var sumPer = document.getElementById('sumPer');
  var sumSave = document.getElementById('sumSave');
  var buyCta = document.getElementById('buyCta');

  function money(n){ var r = Math.round(n * 100) / 100; return '$' + (r % 1 === 0 ? r.toFixed(0) : r.toFixed(2)); }
  function per(t){ var d = TIER[t]; return (state.plan === 'sub' ? d.sub : d.once) / d.count; }
  function setText(sel, txt){ var el = document.querySelector(sel); if (el) el.textContent = txt; }

  function recalc(){
    if (!sumNow || !TIER) return;
    var d = TIER[state.tier];
    var total = state.plan === 'sub' ? d.sub : d.once;
    sumNow.textContent = money(total);
    sumPer.textContent = '$' + per(state.tier).toFixed(2) + ' / serving';
    if (state.plan === 'sub'){ sumSave.style.display = ''; sumSave.textContent = 'You save ' + money(d.once - d.sub); }
    else { sumSave.style.display = 'none'; }
    buyCta.textContent = (state.plan === 'sub' ? 'Start subscription — ' : 'Add to cart — ') + money(total);
    var plan = (state.plan === 'once') ? 'once' : (state.tier === '90' ? 'quarter' : 'sub');
    buyCta.href = productUrl + '?plan=' + plan + '&fmt=' + state.fmt;
    setText('[data-price-30]', money(state.plan === 'sub' ? TIER['30'].sub : TIER['30'].once));
    setText('[data-per-30]', '$' + per('30').toFixed(2) + '/serving');
    setText('[data-price-90]', money(state.plan === 'sub' ? TIER['90'].sub : TIER['90'].once));
    setText('[data-per-90]', '$' + per('90').toFixed(2) + '/serving');
    ['30','90'].forEach(function(t){
      var s = document.querySelector('[data-strike-' + t + ']');
      if (s){ s.style.display = state.plan === 'sub' ? '' : 'none'; s.textContent = money(TIER[t].once); }
    });
  }
  function setPlan(plan){
    state.plan = plan;
    if (planSub){ planSub.classList.toggle('on', plan === 'sub'); planSub.setAttribute('aria-selected', String(plan === 'sub')); }
    if (planOnce){ planOnce.classList.toggle('on', plan === 'once'); planOnce.setAttribute('aria-selected', String(plan === 'once')); }
    recalc();
  }
  if (planSub) planSub.addEventListener('click', function(){ setPlan('sub'); });
  if (planOnce) planOnce.addEventListener('click', function(){ setPlan('once'); });
  if (tiers) [].slice.call(tiers.querySelectorAll('.tier')).forEach(function(t){
    t.addEventListener('click', function(){
      state.tier = t.getAttribute('data-tier');
      [].slice.call(tiers.querySelectorAll('.tier')).forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
      recalc();
    });
  });
  function setBuyFormat(f){
    state.fmt = f;
    if (fmtPills) [].slice.call(fmtPills.querySelectorAll('.fmt-pill')).forEach(function(b){
      b.classList.toggle('on', b.getAttribute('data-fmt') === f);
    });
    recalc();
  }
  if (fmtPills) [].slice.call(fmtPills.querySelectorAll('.fmt-pill')).forEach(function(b){
    b.addEventListener('click', function(){ setBuyFormat(b.getAttribute('data-fmt')); });
  });
  recalc();
})();
